<template>
  <div class="custom-modal" id="make-appointment">
    <div class="modal-body">
      <div class="make-appointment-input-area">
        <div class="make-appointment-input-box">
          <label>{{ $t("appointment.event_name") }}</label>
          <el-select :disabled="participant != null" :placeholder="$t('chooseEvent')" v-model="form.eventId" filterable @clear="form.eventId = null" clearable v-if="authorizedEvents.length != null">
            <el-option v-for="event in authorizedEvents" :key="event.id" :label="event.title" :value="event.id"> </el-option>
          </el-select>
          <span class="error" v-if="validationErrors.some(x => x.key == 'eventId')">{{ validationErrors.find(x => x.key == "eventId").value }}</span>
        </div>
        <div class="make-appointment-input-box">
          <label>{{ $t("appointment.appointment_subject") }}</label>
          <el-input v-model="form.title" :disabled="type == 1" placeholder="..."></el-input>
          <span class="error" v-if="validationErrors.some(x => x.key == 'title')">{{ validationErrors.find(x => x.key == "title").value }}</span>
        </div>
        <div class="make-appointment-input-box">
          <label>{{ $t("appointment.appointment_venue") }}</label>
          <el-input v-model="form.venue" :disabled="type == 1" placeholder="..."></el-input>
          <span class="error" v-if="validationErrors.some(x => x.key == 'venue')">{{ validationErrors.find(x => x.key == "venue").value }}</span>
        </div>
        <div class="make-appointment-input-box" v-if="participant != null">
          <label>{{ $t("appointment.appointment_date") }}</label>
          <el-date-picker
            style="width:100%;"
            type="date"
            :picker-options="{
              disabledDate(time) {
                return timeDiff(time);
              }
            }"
            default-time="12:00:00"
            placeholder="..."
            format="dd MMMM yyyy"
            v-model="form.appointmentDate"
            @clear="
              form.appointmentDate = null;
              getAvailableTimes = [];
            "
          ></el-date-picker>
          <span class="error" v-if="validationErrors.some(x => x.key == 'appointmentDate')">{{ validationErrors.find(x => x.key == "appointmentDate").value }}</span>
        </div>
        <div class="make-appointment-input-box" v-if="participant == null">
          <label>{{ $t("appointment.appointment_date") }}</label>

          <el-date-picker
            style="width:100%;"
            type="date"
            placeholder="..."
            format="dd MMMM yyyy"
            v-model="form.appointmentDate"
            @clear="
              form.appointmentDate = null;
              getAvailableTimes = [];
            "
          ></el-date-picker>
          <span class="error" v-if="validationErrors.some(x => x.key == 'appointmentDate')">{{ validationErrors.find(x => x.key == "appointmentDate").value }}</span>
        </div>
        <div class="make-appointment-input-box" v-if="participant == null">
          <label>{{ $t("appointment.appointment_times") }}</label>

          <el-time-picker style="width:100%;" placeholder="..." value-format="HH:mm" v-model="form.appointmentTime" @clear="form.appointmentTime = null"></el-time-picker>
          <span class="error" v-if="validationErrors.some(x => x.key == 'appointmentTime')">{{ validationErrors.find(x => x.key == "appointmentTime").value }}</span>
        </div>
        <div class="make-appointment-input-box" v-if="participant != null && getAvailableTimes.length > 0">
          <label>{{ $t("appointment.appointment_times") }}</label>

          <el-select v-model="form.appointmentTime" placeholder="...">
            <el-option aria-placeholder="..." v-for="(item, timeIndex) in getAvailableTimes" :key="timeIndex + '-participant-timer'" :label="item.title" :value="item.title" :disabled="!item.isAvailable"></el-option>
          </el-select>
          <span class="error" v-if="validationErrors.some(x => x.key == 'appointmentTime')">{{ validationErrors.find(x => x.key == "appointmentTime").value }}</span>
        </div>
        <div class="make-appointment-input-box">
          <label>{{ $t("appointment.appointment_duration") }}</label>

          <el-select v-model="form.duration" placeholder="..." @clear="form.duration = null" clearable :disabled="participant != null">
            <el-option v-for="time in durationArray" :key="time.duration" :value="time.duration" :label="time.title"> </el-option>
          </el-select>
        </div>
        <div class="make-appointment-input-box" v-if="form.eventId != null">
          <label>{{ $t("appointment.people") }}</label>

          <el-select multiple :disabled="participant != null" v-model="form.userIds" :placeholder="$t('appointment.search_person')" filterable clearable @clear="form.userIds" :remote-method="remoteParticipant">
            <el-option v-for="(item, pantIndex) in participants" :key="item.id + '-participant-item-index-' + pantIndex" :label="item.fullName" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("appointment.close_dialog") }}</el-button>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'save'" @click="saveAppointment">{{ $t("appointment.save") }} </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment/min/moment-with-locales";
export default {
  props: ["participant", "standTitle", "eventId", "type"],
  data() {
    return {
      moment,
      axios,
      loading: false,
      currentEvent: null,
      authorizedEvents: [],
      participants: [],
      getAvailableTimes: [],
      activatedParticipants: false,
      durationArray: [
        {
          title: "00:05",
          duration: 5
        },
        {
          title: "00:10",
          duration: 10
        },
        {
          title: "00:15",
          duration: 15
        },
        {
          title: "00:30",
          duration: 30
        },
        {
          title: "00:45",
          duration: 45
        },
        {
          title: "01:00",
          duration: 60
        },
        {
          title: "01:15",
          duration: 75
        },
        {
          title: "01:30",
          duration: 90
        },
        {
          title: "01:45",
          duration: 105
        },
        {
          title: "02:00",
          duration: 120
        }
      ],
      timeout: null,
      form: {
        appointmentId: null,
        eventId: null,
        userIds: [],
        title: null,
        venue: null,
        duration: null,
        appointmentDate: null,
        appointmentTime: null
      },
      participantError: false,
      validationErrors: []
    };
  },
  watch: {
    "form.appointmentDate": async function() {
      if (this.form.appointmentDate != null && this.form.appointmentDate != undefined) {
        if (this.participant != null && this.participant != undefined) {
          var timeOffSet = new Date(this.form.appointmentDate).getTimezoneOffset();
          axios.defaults.headers["eventID"] = this.form.eventId;

          var res = await this.$store.dispatch("getAvailableTimes", {
            userId: this.participant.userID,
            date: this.moment(this.form.appointmentDate).add(-1 * timeOffSet, "minutes")
          });

          if (!res.data.hasError) {
            this.getAvailableTimes = res.data.data.items;
          }
        }
      }
    },
    "form.eventId": async function() {
      if (this.form.eventId != null && this.form.eventId != undefined) {
        this.participants = [];
        this.form.userIds = [];
        var instance = axios.create();
        instance.defaults.headers["applicationID"] = axios.defaults.headers["applicationID"];
        instance.defaults.headers["eventID"] = this.form.eventId;
        instance.defaults.baseURL = "https://api.holacon.com/v2/";
        var res = await instance.post("participant/getparticipants", {
          skip: 0,
          take: 10000
        });
        this.participants = res.data.data.items;
        if (this.participants != null && this.participants != undefined) {
          const participantUserID = this.participant.userID;
          this.participants.push({
            ...this.participant,
            id: participantUserID,
            fullName: this.participant.firstName + " " + this.participant.lastName
          });
          this.form.userIds.push(this.participant.userID);
        }
      } else {
        this.participants = [];
        this.form.userIds = [];
      }
    }
  },
  beforeDestroy() {
    if (this.getEventInfo != null || this.getEventInfo == undefined) {
      console.log("eventInfo", this.getEventInfo);
      axios.defaults.headers["eventID"] = this.getEventInfo.id;
    }
  },
  methods: {
    timeDiff(time) {
      if (this.currentEvent != null) {
        if (this.currentEvent.id == "635790c4cf5ffb76c498b005") {
          var startDate = new Date("11/4/2022");
          startDate.setHours(0);
          startDate.setMinutes(0);
          startDate.setSeconds(0);
          var endDate = new Date("11/4/2022");
          endDate.setHours(0);
          endDate.setMinutes(0);
          endDate.setSeconds(0);
          var startDiff = startDate.getTime() - time.getTime();
          var endDiff = endDate.getTime() - time.getTime();
          if (startDiff > 0) {
            return true;
          }
          if (endDiff < 0) {
            return true;
          }
        } else {
          var startDate = new Date(this.currentEvent.startDate);
          startDate.setHours(0);
          startDate.setMinutes(0);
          startDate.setSeconds(0);
          var endDate = new Date(this.currentEvent.endDate);
          endDate.setHours(0);
          endDate.setMinutes(0);
          endDate.setSeconds(0);
          var startDiff = startDate.getTime() - time.getTime();
          var endDiff = time.getTime() - endDate.getTime();
          if (startDiff > 0) {
            return true;
          }
          if (endDiff < 0) {
            return true;
          }
        }
        return false;
      }
    }, //muhammet özcan, tolganın karısıdır.
    saveAppointment() {
      var timeOffSet;
      var appointmentDate = null;
      if (this.form.appointmentDate != null && this.form.appointmentDate != undefined) {
        timeOffSet = new Date(this.form.appointmentDate).getTimezoneOffset();
        appointmentDate = this.moment(this.form.appointmentDate).add(-1 * timeOffSet, "minutes");
      }

      this.loading = "save";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        if (this.form.userIds.length == 0) {
          this.$message.error(this.$t("pleaseChooseOneAttendee"));
          this.loading = false;
          this.participantError = true;
          return;
        } else {
          this.participantError = false;
        }
        var res = await this.$store.dispatch("createAppointment", { ...this.form, appointmentDate: appointmentDate });
        this.validationErrors = res.data.validationErrors;
        if (!res.data.hasError) {
          this.$emit("closeDialog");
        }
        this.loading = false;
      }, 500);
    },
    async remoteParticipant(query) {
      var instance = axios.create();
      instance.defaults.headers["applicationID"] = axios.defaults.headers["applicationID"];
      instance.defaults.headers["eventID"] = this.form.eventId;
      instance.defaults.baseURL = "https://api.holacon.com/v2/";
      var res = await instance.post("participant/getparticipants", {
        skip: 0,
        take: 10000,
        searchTerm: query
      });
      this.participants = res.data.data.items;
      if (this.participants != null && this.participants != undefined) {
        const participantUserID = this.participant.userID;
        this.participants.push({ ...this.participant, id: participantUserID });
        this.form.userIds.push(this.participant.userID);
      }
    }
  },
  computed: {
    getEventInfo() {
      return this.$store.getters.getEvent;
    }
  },
  async beforeMount() {
    var res = await axios.post("Explore/SearchEvent", {
      skip: 0,
      take: 10000,
      searchType: 0
    });
    if (!res.data.hasError) {
      this.authorizedEvents = res.data.data.items;
      if (this.eventId != null && this.eventId != undefined) {
        if (this.authorizedEvents.some(x => x.id == this.eventId)) {
          this.currentEvent = this.authorizedEvents.find(x => x.id == this.eventId);
        }
        this.form.eventId = this.eventId;
      }
    }

    if (this.participant != null && this.participant != undefined) {
      this.form.title = this.$t('appointment.b2b');
      if (this.standTitle != null && this.standTitle != undefined) {
        this.form.venue = this.standTitle;
      }
      const participantUserID = this.participant.userID;
      this.participants.push({ ...this.participant, id: participantUserID });

      this.form.userIds.push(this.participant.userID);
      this.form.duration = this.currentEvent.settings.b2BNetworkingInterval;
    }
    if (this.eventId != null && this.eventId != undefined) {
      this.form.eventId = this.eventId;
    }
    if (this.currentEvent && this.currentEvent.startDate != null) {
      var startDate = new Date(this.currentEvent.startDate);
      startDate.setHours(0);
      startDate.setMinutes(0);
      startDate.setSeconds(0);

      this.form.appointmentDate = startDate;
    }
  }
};
</script>

<style lang="less" scoped>
#make-appointment {
  .make-appointment-input-area {
    display: flex; //muhammet özcan, tolganın karısıdır.
    flex-direction: column;
    gap: 8px;

    .make-appointment-input-box {
      display: flex;
      flex-direction: column;
      gap: 8px;

      label {
        font-size: 14px;
        font-weight: bold;
      }

      span.error {
        font-size: 14px;
        font-weight: 500;
        color: red;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MakeAppointment.vue